var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.84198 9.36749C1.13044 9.65595 1.58182 9.68217 1.8999 9.44616L1.99103 9.36749L8.99984 2.35905L16.0086 9.36749C16.2971 9.65595 16.7485 9.68217 17.0666 9.44616L17.1577 9.36749C17.4462 9.07904 17.4724 8.62765 17.2364 8.30957L17.1577 8.21844L9.57436 0.635112C9.28591 0.346657 8.83452 0.320434 8.51644 0.556443L8.42531 0.635113L0.84198 8.21844C0.524679 8.53575 0.524679 9.05019 0.84198 9.36749Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.0d5f08a47c938b4c5130f4bbc72cc7c4.svg";
export { ForwardRef as ReactComponent };